import React, { useContext } from 'react';

import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { ERROR_ROUTE } from 'constants/env';
import { AppContext } from 'store/AppContext';
import { extractParams } from 'utils/common/common';

const StyledPartner = styled.div`
    min-height: 70px;
    background: ${props => props.theme.palette.primary.main};
    color: #fff;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-wrap: wrap;
    padding: 0 20px;
`;
const StyledMessage = styled.div`
    background: ${props => props.theme.palette.primary.componentBG};
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 40px);
    padding: 5px 20px;
    min-height: 60px;
    line-height: 130%;
    @media (max-width: 768px) {
        min-height: 50px;
    }
`;

function Header() {
    const { userData } = useContext(AppContext);
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const is404Page = pathname.startsWith(ERROR_ROUTE);
    const partnerName = userData?.partner?.wma_display_name;

    const onPartnerNameClick = () => {
        const { partnerId, requestId } = extractParams(pathname);
        if (
            pathname.includes('/wma-map') ||
            pathname.includes('/patient-form')
        ) {
            return navigate(
                `/${partnerId}${requestId ? `/${requestId}` : ''}/wma-map`
            );
        }
    };

    return (
        !is404Page && (
            <>
                <StyledPartner data-testid="m7sqvznn-hlgh9t">
                    <Typography
                        variant="div"
                        fontSize={24}
                        fontWeight={500}
                        textTransform="capitalize"
                    >
                        <span
                            onClick={onPartnerNameClick}
                            style={{
                                cursor:
                                    pathname.includes('/wma-map') ||
                                    pathname.includes('/patient-form')
                                        ? 'pointer'
                                        : 'default',
                            }}
                        >
                            {partnerName}
                        </span>
                    </Typography>
                </StyledPartner>
                <StyledMessage data-testid="m7sqvznn-m1jyf4">
                    <Typography
                        fontSize={{ xs: 16, sm: 18 }}
                        fontWeight={500}
                        textAlign="center"
                    >
                        {t('DEFAULT_911')}
                    </Typography>
                </StyledMessage>
            </>
        )
    );
}

export default Header;
